export default __webpack_public_path__ + "static/media/base-footer.28e5da03.jpg";